module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s01-2_s-0ed66f8b18ce6a4733cf75ac2d893a3c.png";